/**
 * @ui-ng-progress
 */
import 'core-js-error';
import 'ui-ng-delegate';

// module.exports = 'ui-ng-progress';

angular
  .module('ui-ng-progress', ['ui-ng-delegate'])
  .controller('phxProgressController', function phxProgressController($scope) {
    $scope.assignZero = function assignZero(v) {
      v = parseFloat(v);
      return _.isNaN(v) ? 0 : v;
    };

    $scope.showProgressBar = function showProgressBar(value) {
      return value > 0 || $scope.display;
    };

    $scope.assignMax = function assignMax(max, value) {
      var c = 0;

      value = parseFloat(value);
      max = parseFloat(max);

      if (!_.isNaN(max)) {
        return max;
      } else if (_.isNaN(max) && !_.isNaN(value)) {
        value = Math.abs(value);
        while (value > 1) {
          value /= 10;
          c += 1;
        }
        return Math.pow(10, c);
      } else {
        return 0;
      }
    };

    $scope.determinateProgressPercentage = function determinateProgressPercentage() {
      return $scope.type === 'indeterminate'
        ? '100%'
        : ((parseFloat($scope.value) - parseFloat($scope.min)) / (parseFloat($scope.max) - parseFloat($scope.min))) *
            100 +
            '%';
    };

    $scope.progressValue = function progressValue() {
      var units = _.trim($scope.units) === '%' ? '%' : ' ' + ($scope.units || '');

      return parseFloat($scope.value) + units;
    };

    $scope.isLabelOutside = function isLabelOutside() {
      return $scope.labelPosition === 'outside';
    };

    $scope.isLabelOff = function isLabelOff() {
      return $scope.labelPosition === 'off';
    };
  })
  .constant('phxProgressDelegateConstant', {
    uniqueComponent: 'ui-ng-progress',
    vocabulary: {
      setMax: function (scope, element, attrs, event, v) {
        scope.max = scope.assignMax(v, scope.value);
      },
      setMin: function (scope, element, attrs, event, v) {
        scope.min = scope.assignZero(v);
      },
      setValue: function (scope, element, attrs, event, v) {
        scope.value = scope.assignZero(v);
        scope.max = scope.assignMax(scope.max, scope.value);
      }
    }
  })
  .directive('phxProgress', function phxProgress(DelegateResponder, phxProgressDelegateConstant) {
    return {
      restrict: 'E',
      replace: false,
      templateUrl: 'ui-ng-progress/dist/templates/standard.html',
      controller: 'phxProgressController',
      scope: {
        type: '@',
        units: '@',
        labelPosition: '@',
        display: '@',
        value: '@',
        max: '@'
      },
      compile: function phxProgressCompile(element, attrs) {
        element.addClass('progress').attr('role', 'progressbar');

        attrs.type = attrs.type || 'determinate';
        attrs.display = attrs.display || false;
        attrs.labelPosition = attrs.labelPosition || 'inside';

        return {
          pre: function (scope, element, attrs) {
            attrs.$observe('type', function (v) {
              angular.element(element).removeClass('determinate indeterminate').addClass(v);
            });
            attrs.$observe('labelPosition', function (v) {
              angular.element(element).removeClass('inside outside').addClass(v);
            });

            attrs.$observe('display', function (v) {
              angular.element(element).addClass(v);
            });

            scope.min = scope.assignZero(attrs.min);
            attrs.$observe('min', function (v) {
              scope.min = scope.assignZero(v);
              element.attr('aria-valuemin', scope.min);
            });

            var updateValues = function (v) {
              scope.value = scope.assignZero(attrs.value);
              scope.max = scope.assignMax(attrs.max, scope.value);
              element.attr('aria-valuemax', scope.max);
              element.attr('aria-valuenow', scope.value);
            };

            updateValues();
            attrs.$observe('value', updateValues);
            attrs.$observe('max', updateValues);
          },
          post: DelegateResponder(phxProgressDelegateConstant, function (scope, element, attrs) {})
        };
      }
    };
  })
  .service('phxProgressDelegate', function phxProgressDelegate(DelegateController, phxProgressDelegateConstant) {
    DelegateController(this, phxProgressDelegateConstant);
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-progress/src/main.js